import { instanceOf, object, oneOfType, shape, string } from "prop-types";

export const DOCX_PREVIEW_ID = "vt_docx_page";
export const DOCX_PREVIEW_STYLES_ID = "vt_docx_preview_styles";

export const DOX_ID_PREFIX = "vt_document_viewer_paragraph_";
export const PAGE_ID_PREFIX = "vt_document_viewer_page_";

export const PAGE_INTRO_LIMIT = 150;

// Scrolling to a quote can only highlight it once the target has actually been
// rendered: the virtualizer must mount the row, and for a PDF pdf.js then
// builds the text layer in a second, asynchronous pass. Both are unbounded in
// wall-clock terms, so we poll for the target instead of guessing a delay.
export const RENDER_WAIT_TIMEOUT_MS = 10000;
export const RENDER_POLL_INTERVAL_MS = 50;

// A mounted page that still has no text is either image-only or simply not the
// page the quote is on. Waiting the full timeout for text that will never come
// would hold the loading mask up for no reason, so give those pages a much
// shorter grace period than a page we are still waiting to render at all.
export const TEXT_LAYER_GRACE_MS = 2000;

export const REMOVE_STYLE_ATTR_REGEX = /style="[^"]+"/g;

export const A4_WIDTH_72DPI = 595;
export const A4_HEIGHT_72DPI = 842;
export const SCROLLBAR_DITHER = 10;

export const FILE_PROP_TYPE = oneOfType([
  shape({
    url: string,
    headers: object,
  }),
  instanceOf(File),
]);
